import { Button, ConfirmationDialog, NoResults, Table } from 'src/components';
import { type ChangeEvent, useState } from 'react';
import {
	Checkbox,
	FormControlLabel,
	Grid,
	Typography,
} from '@material-ui/core';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import { userTypes } from '../../../../../../../helpers/constants';
import VideoDialog from './VideoDialog/VideoDialog';
import VideoPreview from './VideoPreview';
import _ from 'lodash';
import useStyles from './Videos-styles';
import videoActions from 'src/store/Videos/actions';

import { type IVideo } from 'src/models';
import { getTime } from 'src/helpers';
import sectionActions from 'src/store/Sections/actions';

const columns = [
	{
		key: 'name',
		label: 'Título',
		render: (value: any, row: any) => value,
	},
	{
		key: 'duration',
		label: 'Duración',
		render: (value: any, row: any) => getTime(value),
	},
];

function Videos() {
	const classes = useStyles();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const user = useSelector(state => state.auth.data);
	const section = useSelector(state => state.sections.section);
	const videoDialogOpen = useSelector(state => state.sections.videoDialogOpen)

	const deletevideo = (id: number) => dispatch(videoActions.remove(id));
	const updateOrder = (sectionId: number, videos: IVideo[]) =>
		dispatch(videoActions.updateOrder(sectionId, videos));
	const handleActvation = (id: number, value: boolean) =>
		dispatch(videoActions.handleActivation(id, value));

	const [dialog, setDialog] = useState({
		isNew: true,
		open: false,
		video: {},
	});
	const [preview, setPreview] = useState({ open: false, video: {} });
	const [confirmation, setConfirmation] = useState({
		id: 0,
		key: '',
		open: false,
	});

	const actions = [
		{
			label: 'Activo',
			onClick: () => { },
			render: function Component(row: any) {
				return (
					<FormControlLabel
						control={
							<Checkbox
								checked={row.active}
								color={'secondary'}
								onChange={(
									event: ChangeEvent<HTMLInputElement>,
								) =>
									handleActvation(
										row.id,
										event.target.checked,
									)
								}
								size={'small'}
							/>
						}
						key={row.id}
						label={
							<Typography style={{ fontSize: 12 }}>
								{' '}
								Activo{' '}
							</Typography>
						}
					/>
				);
			},
		},
		{
			label: 'Preview',
			onClick: (row: any) => {
				setPreview({ open: true, video: row });
			},
		},
		{
			label: 'Editar',
			onClick: (row: any) => {
				setDialog({ isNew: false, open: true, video: row });
				dispatch(sectionActions.set('videoDialogOpen', true));
			},
		},
		{
			label: 'Eliminar',
			onClick: (row: any) => {
				setConfirmation({ id: row.id, key: row.key, open: true });
			},
		},
	];

	const restrictedActions = [
		{
			label: 'Preview',
			onClick: (row: any) => {
				setPreview({ open: true, video: row });
			},
		},
	];

	async function handleDelete(id: number, key: string) {
		deletevideo(id);
		// await deleteFile(key);
	}

	return (
		<Grid container>
			<VideoDialog
				handleOpen={() => {
					setDialog({ isNew: true, open: false, video: {} });
					dispatch(sectionActions.set('videoDialogOpen', !videoDialogOpen));
				}}
				isNew={dialog.isNew}
				open={videoDialogOpen}
				video={dialog.video}
			/>

			<VideoPreview
				handleOpen={() => {
					setPreview({ open: false, video: {} });
				}}
				open={preview.open}
				video={preview.video}
			/>

			<ConfirmationDialog
				onClose={() => {
					setConfirmation({ id: 0, key: '', open: false });
				}}
				onConfirm={async () => {
					await handleDelete(confirmation.id, confirmation.key);
				}}
				open={confirmation.open}
				title={'¿Deseas eliminar este vídeo?'}
			/>

			<h2> Vídeos </h2>

			<Grid container item spacing={2} xs={12}>
				{section?.videos?.length === 0 ? (
					<NoResults text={'No hay vídeos'} />
				) : (
					<Grid item style={{ padding: 16 }} xs={12}>
						<Table
							actions={
								user.type === userTypes.ADMIN
									? actions
									: restrictedActions
							}
							columns={columns}
							data={_.sortBy(section.videos, 'sortOrder')}
							enableDrag={user.type === userTypes.ADMIN}
							handleDrag={(reorderedData: any[]) =>
								updateOrder(section.id!, reorderedData)
							}
							hidePagination
						/>
					</Grid>
				)}
			</Grid>

			<Grid className={classes.actions} item xs={12}>
				{user.type === userTypes.ADMIN && (
					<Button
						actionType={'add'}
						onClick={() => {
							setDialog({ isNew: true, open: true, video: {} });
							dispatch(sectionActions.set('videoDialogOpen', true));
						}}
					>
						Agregar vídeo
					</Button>
				)}
			</Grid>
		</Grid>
	);
}

export default Videos;
